<mat-form-field class="First">
  <div class="select">
    <div class="label">
      <span style="color: #e00000; margin-right: 5px">*</span>{{ label }}：
    </div>
    <mat-form-field>
      <mat-select [formControl]="formControl" required>
        <mat-option *ngFor="let item of data" [value]="item.value">
          {{ item.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="divider"></div>
  <mat-error *ngIf="formControl?.hasError('required')">
    请将信息填写完整
  </mat-error>
</mat-form-field>
